export const SHOW_CONTACT_DETAILS = 'SHOW_CONTACT_DETAILS';
export const SHOW_CHAT_HEADS = 'SHOW_CHAT_HEADS';
export const SHOW_MESSAGES = 'SHOW_MESSAGES';
export const SET_PAGE = 'SET_PAGE';
